// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"527":"c2ee2a7d","5567":"c8588408","8331":"c2ee2a7d","8821":"10541459","9855":"c2ee2a7d"}[chunkId] + ".css";
};